export default "__VITE_ASSET__BKkh7uvL__"